import { render } from "./AlBeverage.vue?vue&type=template&id=5e68f725&scoped=true"
import script from "./AlBeverage.vue?vue&type=script&lang=js"
export * from "./AlBeverage.vue?vue&type=script&lang=js"

import "./AlBeverage.vue?vue&type=style&index=0&id=5e68f725&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e68f725"]])

export default __exports__